<div class="el-breadcrumb-wrapper">
  <div class="container ">
    <div class="el-breadcrmb-inner  ">
      <h1 style="color: #e04787;">Book Details</h1>
      <ul>

        <!-- <li>
          <select class="form-control border rounded " [(ngModel)]="selectedYear" (change)="onYearChange()">
            <option value="" disabled hidden>Select Financial Year</option>
            <option *ngFor="let year of FYearList" [value]="year">{{ year }}</option>
          </select>
        </li> -->

        <li class="ms-3">
          <a [routerLink]="['/dashboard']" style="color: #e04787;"><i class="fa fa-reply " aria-hidden="true"></i>
            Back</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="el-team-wrapper">
  <div class="container">
    <div class="el-team-heading text-center">
      <h4 class="el-top-heading-center">Book Details</h4>
    </div>
    <div class="el-team-parent ">

      <div class="row gy-3">
        <ng-container *ngFor="let book of listBookDetails; let i = index">
          <div class="col-md-3 d-flex" *ngIf="book.plan>2 && book.plan < 4">
            <div class="el-team-box ">
              <div class="el-team-box-inner">
                <div class="el-team-img">
                  <img class="p-2" [src]="'https://service.silverzone.org/Img/Web/Admin/BookImage/' + book.bookImage"
                    alt="Team Member">

                </div>
                <div class="el-team-content">
                  <h4>{{ book.title }}</h4>
                  <!-- <p class="el-para"><img src="../assets/images/all-instructor/team-icon.png" alt="icon"> 3D Animation</p> -->
                  <div class="">

                    <a class="el-btn py-2 mt-2" target="_blank" [routerLink]="['/eBook']"
                      [queryParams]="{ id: book.pdF_Path | getPdfId, BookName: book.title,BookId: book.bookId }"
                      *ngIf="bookType !==1">

                      <i class="fa fa-book"></i>&nbsp; Read Me
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="d-flex justify-content-center">
          <div class="col-md-5 alert" *ngIf="onlyPlan2">
            <i class="fa fa-exclamation-triangle" aria-hidden="true" style="font-size: 50px;color: #e04787;"></i>
            <br><br>
            <h5>Oops! You don’t have access to study material yet. <br /> Unlock study resources by upgrading your plan.
            </h5>
            <h5 class="el-btn py-2 mt-2" [routerLink]="['/buy-products']"
              style="cursor: pointer; color: rgb(227, 227, 236);">
              Upgrade for Access
            </h5>
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <div class="col-md-5 alert" *ngIf="!listBookDetails || listBookDetails.length === 0">
            <i class="fa fa-exclamation-triangle" aria-hidden="true" style="font-size: 50px;color: #e04787;"></i>
            <br><br>
            <h5>Oops! You don’t have access to study material yet. <br /> Select a package to get started.</h5>
            <h5 class="el-btn py-2 mt-2" [routerLink]="['/buy-products']"
              style="cursor: pointer; color: rgb(236, 236, 241);">
              Buy Now
            </h5>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>


<!-- <div class="el-cart-wrapper">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="woo-cart-table">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Book image</th>
                  <th>Courses</th>
                  <th>Quantity</th>
                  <th>Title</th>
                  <th>OrderDate</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td><img src="../assets/images/all-instructor/ai-guide.png" alt="event image" width="100"></td>
                  <td>Science</td>
                  <td>1</td>
                  <td><span>Artificial Intelligence (AI)</span></td>
                  <td>2024-10-30 (Wednesday)
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td><img src="../assets/images/all-instructor/ai-guide.png" alt="event image" width="100"></td>
                  <td>Science</td>
                  <td>1</td>
                  <td><span>Artificial Intelligence (AI)</span></td>
                  <td>2024-10-30 (Wednesday)
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>


    </div>
  </div>
</div> -->

<!-- <div class="card shadow mt-5  mb-5 mx-auto" style="max-width:90%px;">
  <div class="card-body">
    <h5 class="card-title mb-4">BookDetails</h5>
    <h5 [routerLink]="['/dashboard']" class="card-title mb-4">Go BACK</h5>
    <table class="table table-striped table-bordered text-center">
      <thead class="table-dark">
        <tr>
          <th scope="col">SR NO</th>
          <th>orderDate</th>
          <th>title</th>
          <th>quantity</th>

        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let book of listBookDetails;let i = index">
          <td scope="col">{{i+1}}</td>
          <td>{{book.orderDate }}</td>
          <td>{{book.title}}</td>
          <td>{{book.quantity}}</td>

        </tr>
        <tr *ngIf="listBookDetails.length === 0">
          <td colspan="6" class="text-center">No details available</td>
      </tbody>
    </table>

    <ul>
      <li>

      </li>
    </ul>

  </div>
</div> -->